import type { ITableSorting } from '@model/tableSorting';

export const onChangeSorting = (
  key: string,
  sorting: ITableSorting,
  initialSorting: ITableSorting,
  setSorting: (sorting: ITableSorting) => void,
) => {
  if (!sorting.id || sorting.id !== key) {
    setSorting({ id: key, desc: false });
    return;
  }
  const { id, desc } = sorting;
  if (desc) {
    setSorting(initialSorting);
  } else {
    setSorting({ id, desc: true });
  }
};
